import { render } from "./SProjekts.vue?vue&type=template&id=70fc5698"
import script from "./SProjekts.vue?vue&type=script&lang=js"
export * from "./SProjekts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__